import { createFileRoute } from '@tanstack/react-router'

import { RoleGate } from '@/components/guards'
import { TaxSettingsPage } from '@/pages/settings/organization/TaxSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/tax/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <RoleGate requires="ADMIN">
      <TaxSettingsPage />
    </RoleGate>
  )
}
